import { useField, useForm } from 'components/Form/hooks'
import React from 'react'
import { useIntl } from 'react-intl'
import Separator from 'ui/Separator'
import { UpdateFormContext } from 'utils/types/updateForm'
import theme from 'utils/theme'
import { MAX_TITLE_COUNTER_CHARACTERS } from 'utils/constants/updates'
import { DatePicker, Input, TextArea } from '../commons'
import MediaUploader from '../MediaUploader/MediaUploader'
import { Content, Row } from './DocumentForm.styles'
import MultipleFundSelector from '../commons/InvestorFundSelector/MultipleInvestorFundSelector'

const DocumentForm: React.FC = () => {
  const intl = useIntl()
  const { disabled, showInvestorAndFundSelector } = useForm<UpdateFormContext>()
  const [titleField] = useField('title')

  return (
    <Content>
      <Row>
        <Input
          id="title"
          label={intl.formatMessage({
            id: 'updates.document.title.label',
          })}
          name="title"
          placeholder={intl.formatMessage({
            id: 'updates.document.title.placeholder',
          })}
          title={intl.formatMessage({
            id: 'updates.document.title.label',
          })}
          withCounter
          customMaxCounterCharacters={MAX_TITLE_COUNTER_CHARACTERS}
          counterSubtractNumber={titleField.value?.length}
          simulateIconSpace
          counterStyle={{
            right: '2rem',
            top: '1.2rem',
            color: theme.colors.darkGray,
            opacity: 0.5,
          }}
          extraPaddingRight={1.5}
        />
        <DatePicker
          id="date"
          name="date"
          label={intl.formatMessage({
            id: 'updates.document.date.label',
          })}
        />
      </Row>
      <Separator />

      {!!showInvestorAndFundSelector && <MultipleFundSelector />}

      <TextArea
        id="body"
        label={intl.formatMessage({
          id: 'updates.document.additionalMessage.label',
        })}
        isOptional
        name="body"
        title={intl.formatMessage({
          id: 'updates.document.additionalMessage.label',
        })}
        placeholder={intl.formatMessage({
          id: 'updates.document.additionalMessage.placeholder',
        })}
      />

      <MediaUploader disabled={disabled} name="files" />
    </Content>
  )
}

export default DocumentForm
